module.exports = __webpack_public_path__ + "media/images/gallery/main_off-f5262ef98e2d3b1233bc38e99a0d7ece.gif";